import { SimpleGuard } from 'interfaces/guards'
import { popularProvidersSelector } from 'selectors/linkageSelectors'
import { getProvidersActionCreator } from 'actions/linkageActions'

export const popularProvidersGuard: SimpleGuard<{}> = {
  name: 'Popular Providers',
  checker: (state) => !!popularProvidersSelector(state),
  loader: (dispatch) => dispatch(getProvidersActionCreator.request({ mode: 'popular' })),
}
